<div
  [ngStyle]="{ background: 'url(assets/images/MADB-BANNER-5.jpg)' }"
  class="content-header"
>
  <span class="header-title">Aircraft</span>
</div>
<div class="form">
  <div class="section-container">
    <div class="title">
      <h2>Add/Edit Aircraft</h2>
    </div>
    <div class="content">
      <div class="datum">
        <div class="input-container">
          <span class="input-label">Call Sign: </span>
          <input
            aria-label="Call Sign"
            maxlength="50"
            type="text"
            [(ngModel)]="aircraft.callsign"
            placeholder="Call Sign"
          />
        </div>
      </div>
      <div class="datum">
        <div class="input-container">
          <span class="input-label"
            >Make/Model: <span class="required-asterisk">*</span></span
          >
          <input
            aria-label="Make / Model"
            maxlength="20"
            type="text"
            [(ngModel)]="aircraft.Aircraft_Name"
            placeholder="Make/Model"
          />
        </div>
      </div>
      <div class="datum">
        <div class="input-container">
          <span class="input-label">Tail Number: </span>
          <input
            aria-label="Tail Number"
            maxlength="10"
            type="text"
            [(ngModel)]="aircraft.Aircraft_Tail_Number"
            placeholder="Tail Number"
          />
        </div>
      </div>
      <div class="datum">
        <div class="input-container">
          <span class="input-label">Aircraft Owner: </span>
          <input
            aria-label="Owner"
            maxlength="15"
            type="text"
            [(ngModel)]="aircraft.Aircraft_Owner"
            placeholder="Owner"
          />
        </div>
      </div>
      <div class="datum" *ngIf="mode === 'Update'">
        <div class="input-container">
          <span class="input-label">Active: </span>
          <input
            aria-label="Active"
            type="checkbox"
            [(ngModel)]="aircraft.active"
          />
        </div>
      </div>
    </div>
    <div class="buttons">
      <app-button
        [disabled]="aircraft.Aircraft_Name.length < 1"
        (clicked)="submitForm($event)"
        text="Submit"
      ></app-button>
      <app-button
        style="margin-left: 20px"
        (clicked)="goToAircraft()"
        cancel="true"
        text="Cancel"
        class="cancel-button"
      ></app-button>
    </div>
  </div>
</div>
